import {sleep, useMock} from "../utils/helpers";
import http from "../plugins/http";
import config from '../config';

const uri = config.services.rating;

class Assets {
  constructor() {
    this.useMock = useMock('assets');
  }

  async fetchAssets(ids) {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(2000);
        resolve((await import('../../mock/assets.js')).byIds(ids));
      });
    }

    const params = {
      ids
    };

    const {data} = await http.get(`${uri}/api/v1/assets/list`, { params });

    return data.data.items;
  };

  async fetchAsset(id) {
    console.log('fetchAsset', id)
    const {data} = await http.get(`${uri}/api/v1/assets/${id}/details`);
    console.log('fetchAsset r', data)

    return data.data;
  };

  async fetchAllAssets(withoutIds, token) {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(1000);
        resolve((await import('../../mock/assets.js')).getAllAssets(withoutIds));
      });
    }

    const {data} = await http.get(`${uri}/api/v1/assets`);

    return data.data;
  };

  async fetchAssetsByFilter(filter) {
    const params = {};

    params.limit = filter.limit || 25;
    params.page = filter.page || 1;
    params.sort = filter.sort || '';
    params.type = filter.type || 'all';

    if(filter.sort) {
      params.sort = filter.sort;
    }

    const {data} = await http.get(`${uri}/api/v1/assets/list`, { params });

    return data.data;
  }

  async followToAsset(id) {
    const {data} = await http.post(`${uri}/api/v1/assets/${id}/follow`);
  }

  async searchCriteria(search, token) {
    const params = {
      q: search,
    };

    const {data} = await http.get(`${uri}/api/v1/search/criteria`, { params });

    return data.data;
  }

  async fetchAllCriteria() {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(1000);
        resolve((await import('../../mock/assets.js')).getAllCriteria());
      });
    }

    const {data} = await http.get(`${uri}/api/v1/criteria`);

    return data.data;
  };

  async fetchCriterion(id, token) {
    const {data} = await http.get(`${uri}/api/v1/criteria/${id}`);
    console.log('cirririri fetchCriterion',`${uri}/api/v1/criteria/${id}`, data)

    return data.data;
  }

  async fetchSector(id, token) {
    const {data} = await http.get(`${uri}/api/v1/sectors/${id}`);

    return data.data;
  }

  async fetchAllSectors() {
    if(this.useMock) {
      return new Promise(async resolve => {
        await sleep(1000);
        resolve((await import('../../mock/assets.js')).getAllSectors());
      });
    }

    const {data} = await http.get(`${uri}/api/v1/sectors`);

    return data.data;
  }
}

export default new Assets();



// WEBPACK FOOTER //
// ./src/services/assets.js